export default "__VITE_ASSET__CWSRKkkC__"